import { render, staticRenderFns } from "./shipment_usage.vue?vue&type=template&id=38f9d14e"
import script from "./shipment_usage.vue?vue&type=script&lang=js"
export * from "./shipment_usage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports